import { tw } from '@/utils/tw';
import BaseImage from 'base/components/standalone/Image/theme';

const Image = tw.theme({
  extend: BaseImage,
  slots: {
    captionGroup: 'text-black text-body-sm',
    byline: 'text-gray-600',
  },
});

export default Image;
